import { Component, OnInit } from "@angular/core"
import { Produto } from "../../model/produto";
import { ProdutoServico } from "../../servicos/produto/produto.servico";
import { Router } from "@angular/router";
import { TipoProduto } from "../../model/tipoProduto";

@Component({
  selector: "app-produto",
  templateUrl: "./cadastro.produto.component.html",
  styleUrls: ["./cadastro.produto.component.css"]
})
export class CadastroProdutoComponent implements OnInit {
  public produto: Produto;
  public tiposProduto: TipoProduto[];
  public arquivoSelecionado: File;
  public ativar_spinner: boolean;
  public mensagem: string;

  constructor(private produtoServico: ProdutoServico, private router: Router) {
    this.produtoServico.obterTodosTiposProduto()
      .subscribe(
        tp => {
          this.tiposProduto = tp;
        },
        err => {
          console.log(err.error);
        }
      )
  }

  ngOnInit(): void {
    var produtoSession = sessionStorage.getItem('produtoSession');

    if (produtoSession) {
      this.produto = JSON.parse(produtoSession);
    }
    else {
      this.produto = new Produto();
    }
  }

  public inputChange(files: FileList) {
    this.arquivoSelecionado = files.item(0);
    this.ativarEspera();
    this.produtoServico.enviarArquivo(this.arquivoSelecionado)
      .subscribe(
        nomeArquivo => {
          this.produto.nomeArquivo = nomeArquivo;
          this.desativarEspera();
        },
        err => {
          console.log(err.error);
          this.desativarEspera();
        }
      );
  }

  public cadastrar() {
    this.ativarEspera();
    this.produtoServico.cadastrar(this.produto)
      .subscribe(
        produtoRetorno => {
          sessionStorage.removeItem('produtoSession');
          this.desativarEspera();
          this.router.navigate(['/pesquisar-produto']);
        },
        err => {
          this.mensagem = err.error;
          this.desativarEspera();
        }
      );
  }

  public ativarEspera() {
    this.ativar_spinner = true;
  }

  public desativarEspera() {
    this.ativar_spinner = false;
  }
}
